import { Navigate } from 'react-router-dom';
import { usePlatformAuthStore } from '@/features/platform-auth/store';

interface Props {
  children: React.ReactNode;
}

/**
 * Route guard for the Platform Console.
 * - While the store is rehydrating from localStorage: show a fullscreen spinner.
 * - Once hydrated, if there's no admin session: redirect to /platform/login.
 * - Otherwise: render children (which will be PlatformShell via Outlet).
 */
export function PlatformProtectedRoute({ children }: Props) {
  const admin = usePlatformAuthStore((s) => s.admin);
  const isHydrated = usePlatformAuthStore((s) => s.isHydrated);

  if (!isHydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-plat-bg">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-plat-border border-t-blue-500" />
          <p className="text-sm text-plat-muted">Loading Platform Console…</p>
        </div>
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/platform/login" replace />;
  }

  return <>{children}</>;
}
